import { z } from 'zod';
import { SanityDocumentSchema } from '../sanity';
import { EntityType } from '../../types';
import { LinkFieldsSchema } from '../shared';

export const FooterSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.Footer),
  title: z.string().optional(),
  socialLinksTitle: z.string().optional(),
  socialLinks: z.array(LinkFieldsSchema),
  buLinksTitle: z.string().optional(),
  buLinks: z.array(LinkFieldsSchema),
  companyLinksTitle: z.string().optional(),
  companyLinks: z.array(LinkFieldsSchema)
});

export type Footer = z.infer<typeof FooterSchema>;
